import React from "react";
import Paths from "../../constants/Paths";
import Login from "../Login/Login";
import ForgotPassword from "../Login/ForgotPassword";
import ResetPassword from "../Login/ResetPassword";
import TwoFAuth from "../Login/TwoFactorAuthentication/TwoFAuth";
const exact = true;
const CoreRoutes = (customSiteConfigurations) => [
  {
    exact,
    path: Paths.Login,
    component: (props) => (
      <Login customSiteConfigurations={customSiteConfigurations} {...props} />
    ),
  },
  ...(!customSiteConfigurations.ForgotPassword
    ? [
        {
          exact,
          path: Paths.ForgotPassword,
          component: (props) => <ForgotPassword {...props} />,
        },
      ]
    : []),
  {
    exact,
    path: Paths.ResetPassword,
    component: (props) => <ResetPassword {...props} />,
  },
  {
    exact,
    path: Paths.TwoFAuth,
    component: (props) => <TwoFAuth {...props} />,
  },
];

export default CoreRoutes;
